<template>
  <div id="app">
    <router-view/>
    <div id="wx-qrimg">
      <div class="qr-name">扫一扫 欢迎关注</div> 
      <img :src="wx" />
      <div class="qr-name-welcome">中国老教授协会 微信公众号</div> 
    </div>
  </div>
</template>

<script>
import wx from "@/assets/images/wx.jpg"
export default {
  //wx,
  data() {
    return {
      wx: wx
    }
  }
}
</script>